import chat from './chat.svg';
import contactCenter from './contact-center.svg';
import email from './correo.svg';
import factura from './factura.svg';
import iconTag from './icon-tag.svg';
import profile from './profile.svg';
import properties from './properties.svg';
import support from './support.svg';
import search from './search.svg';

export const Icons = {
  iconTag,
  factura,
  profile,
  properties,
  contactCenter,
  email,
  chat,
  support,
  search,
};
